import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { GET_USER_TENANTS_ENDPOINT } from '../constants/endpoints.constants';
import { UserTenant } from '@data';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly apiService = inject(ApiService);

  getUserTenants(): Observable<UserTenant[]> {
    return this.apiService
      .get<{ distributors: UserTenant[] }>(GET_USER_TENANTS_ENDPOINT)
      .pipe(map((res) => res.distributors));
  }
}
